import { Button, ButtonText } from '@/ui/core/button'
import { Sheet, SheetTitle } from '@/ui/core/sheet'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

/**
 * The way out, asked for before it is taken.
 *
 * A sheet rather than a dialog, so the one thing that interrupts a screen in this app is the
 * thing that slides up from its foot, wearing the same title the rest of them wear. It closes on
 * a tap outside, which is the safe answer here: the gesture that dismisses it is the one that
 * keeps the answers.
 *
 * Leaving is the loud button because it is what was asked for, and staying is the quiet one
 * beneath it. Nothing is coloured for danger: no answers have been sent yet, so this is a page
 * being abandoned rather than a record being destroyed.
 */
export const LeaveSheet = ({
	open,
	onClose,
	onLeave,
}: { open: boolean; onClose: () => void; onLeave: () => void }) => (
	<Sheet open={open} onClose={onClose}>
		<SheetTitle glyph="x">Leave this form?</SheetTitle>
		<VStack gap={24} className="px-4 pb-2">
			<Text size="body0" tone="soft">
				Your answers so far will not be saved. You can start again any time.
			</Text>
			<VStack gap={14}>
				<Button fullWidth onPress={onLeave}>
					<ButtonText>Leave</ButtonText>
				</Button>
				{/* A button sets its own alignment, full width or hugging, so the column it sits in
				    cannot centre it: the link has to say so itself. */}
				<Button variant="link" className="self-center" onPress={onClose}>
					<ButtonText>Keep Going</ButtonText>
				</Button>
			</VStack>
		</VStack>
	</Sheet>
)
